import { useLocation } from "react-router-dom";
import { useHistoryBack } from "./useHistoryBack";

export type AnalyticsBackState = { analyticsCanGoBack: boolean };

function isAnalyticsBackState(state: unknown): state is AnalyticsBackState {
  return (
    typeof state === "object" &&
    state !== null &&
    "analyticsCanGoBack" in state &&
    typeof state.analyticsCanGoBack === "boolean"
  );
}

/**
 * Router state to carry across in-analytics navigations (tab switches, date
 * changes). Analytics history entries are replaced, so the flag computed on the
 * first analytics page must survive every replace.
 */
export function useAnalyticsBackState(): AnalyticsBackState {
  const location = useLocation();
  return {
    analyticsCanGoBack: isAnalyticsBackState(location.state)
      ? location.state.analyticsCanGoBack
      : location.key !== "default",
  };
}

/** Back handler leaving analytics, or undefined when it was opened directly. */
export function useAnalyticsBack(): (() => void) | undefined {
  const { analyticsCanGoBack } = useAnalyticsBackState();
  return useHistoryBack(analyticsCanGoBack);
}
